import React, { useState, useEffect, useMemo } from "react";
import { postProveedor } from "../helpers/rutaProveedores";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getIva } from "../helpers/rutaIva";
import "../css/addclienteform.css";
import { Modal, Button } from "react-bootstrap";
import "../css/modalformalert.css";
import { FaThumbsUp } from "react-icons/fa";

const AddProveedorForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    codprov: "",
    razonsocial: "",
    domicilio: "",
    telefono: "",
    cuit: "",
    email: "",
    localidad: "",
    condicioniva: "",
    ruta: "", // si después lo usás
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [localidades, setLocalidades] = useState({ data: { localidades: [] }, loading: true, error: "" });
  const [iva, setIva] = useState({ data: { iva: [] }, loading: true, error: "" });

  useEffect(() => {
    (async () => {
      try {
        const locs = await getLocalidades();
        setLocalidades({ data: locs || { localidades: [] }, loading: false, error: "" });
      } catch (e) {
        setLocalidades({ data: { localidades: [] }, loading: false, error: e?.message || "Error al cargar localidades" });
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const iv = await getIva();
        setIva({ data: iv || { iva: [] }, loading: false, error: "" });
      } catch (e) {
        setIva({ data: { iva: [] }, loading: false, error: e?.message || "Error al cargar IVA" });
      }
    })();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((s) => ({ ...s, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resp = await postProveedor(formValues);
      console.log("✅ Proveedor creado:", resp);
      // Si tu back usa {ok:false,error:"..."}:
      if (resp?.ok === false) {
        alert(resp.error || "No se pudo crear el proveedor");
        return;
      }
      setFormValues({
        codprov: "",
        razonsocial: "",
        domicilio: "",
        telefono: "",
        cuit: "",
        email: "",
        localidad: "",
        condicioniva: "",
        ruta: "",
      });
      setShowSuccessModal(true);
    } catch (err) {
      console.error("❌ Error POST /proveedores:", err?.response || err);
      alert(`No se pudo crear el proveedor${err?.response?.status ? ` (${err.response.status})` : ""}.`);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setShow(false); // cerrar modal padre
  };

  // --- Opciones ordenadas alfabéticamente ---
  const opcionesLocalidades = useMemo(() => {
    return [...(localidades?.data?.localidades || [])]
      .filter((l) => l?.activo ?? true)
      .sort((a, b) =>
        (a.localidad || "").localeCompare(b.localidad || "", "es", { sensitivity: "base" })
      );
  }, [localidades]);

  const opcionesIva = useMemo(() => {
    return [...(iva?.data?.iva || [])]
      .sort((a, b) =>
        (a.iva || "").localeCompare(b.iva || "", "es", { sensitivity: "base" })
      );
  }, [iva]);

  if (localidades.loading || iva.loading) return <div className="p-3">Cargando…</div>;
  if (localidades.error) return <div className="p-3 text-danger">{localidades.error}</div>;
  if (iva.error) return <div className="p-3 text-danger">{iva.error}</div>;

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-2">
              <label>Cod Prov</label>
              <input
                type="text"
                className="form-control"
                name="codprov"
                maxLength="20"
                required
                value={formValues.codprov}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Razón Social</label>
              <input
                type="text"
                className="form-control"
                name="razonsocial"
                maxLength="50"
                required
                value={formValues.razonsocial}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Domicilio</label>
              <input
                type="text"
                className="form-control"
                name="domicilio"
                maxLength="50"
                required
                value={formValues.domicilio}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-2">
              <label>Teléfono</label>
              <input
                type="text"
                className="form-control"
                name="telefono"
                maxLength="20"
                value={formValues.telefono}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group mt-3 col-sm-2">
              <label>CUIT</label>
              <input
                type="text"
                className="form-control"
                name="cuit"
                maxLength="11"
                value={formValues.cuit}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-4">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                maxLength="50"
                value={formValues.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Localidad</label>
              <select
                className="form-control"
                name="localidad"
                value={formValues.localidad}
                onChange={handleChange}
                required
              >
                <option value="">Elija opción</option>
                {opcionesLocalidades.map((localidad) => (
                  <option key={localidad._id} value={localidad._id}>
                    {localidad.localidad}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-3 col-sm-3">
              <label>Condición IVA</label>
              <select
                className="form-control"
                name="condicioniva"
                value={formValues.condicioniva}
                onChange={handleChange}
                required
              >
                <option value="">Elija opción</option>
                {opcionesIva.map((it) => (
                  <option key={it._id} value={it._id}>
                    {it.iva}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>


      {/* Modal de éxito */}
      <Modal show={showSuccessModal} onHide={handleSuccessClose} centered>
        <div className="custom-modal">
          <div className="custom-modal-icon">
            <FaThumbsUp />
          </div>
          <Modal.Body className="custom-modal-body">
            <h4>Info</h4>
            <p>¡Registro agregado correctamente!</p>
          </Modal.Body>
          <Button className="custom-modal-button" onClick={handleSuccessClose}>
            Aceptar
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AddProveedorForm;
